import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Component, ElementRef, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Component({
  selector: 'split-button',
  standalone: false,
  templateUrl: './split-button.component.html',
  styleUrl: './split-button.component.scss'
})
  export class SplitButtonComponent {
    private overlay = inject(Overlay);
    private elementRef = inject(ElementRef);
    private viewContainerRef = inject(ViewContainerRef);

    @Input() text: string;

    private overlayRef: OverlayRef | null = null;

  toggleMenu(trigger: ElementRef, menuTemplate: TemplateRef<any>): void {
    if (this.overlayRef?.hasAttached()) {
      this.closeMenu();
    } else {
      this.openMenu(trigger, menuTemplate);
    }
  }

  private openMenu(trigger: ElementRef, menuTemplate: TemplateRef<any>): void {
    this.overlayRef = this.createOverlay(trigger);

    this.overlayRef.backdropClick().subscribe(() => this.closeMenu());
    this.overlayRef.overlayElement.addEventListener('click', () => this.closeMenu());

    const splitButtonWidth = this.elementRef.nativeElement.offsetWidth;
    this.overlayRef.overlayElement.style.setProperty('--menu-width', `${splitButtonWidth}px`);

    const portal = new TemplatePortal(menuTemplate, this.viewContainerRef);
    this.overlayRef.attach(portal);
  }

  private closeMenu(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  ngOnDestroy(): void {
    this.closeMenu();
  }

  private createOverlay(trigger: ElementRef): OverlayRef {
    const positionStrategy = this.overlay.position().flexibleConnectedTo(trigger).withPositions([
      { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top',    offsetY: 2  },
      { originX: 'end', originY: 'top',    overlayX: 'end', overlayY: 'bottom', offsetY: -2 },
    ]);

    return this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });
  }
}
